import React, { useCallback, useEffect, useMemo, useState } from 'react'
import ApplicationCooLayout from '../../layout/application-coo-layout';
import { P2Button, P2ButtonGroup, P2Modal, P2TextDescription } from 'react-bootstrap-common-script';
import { AddressSelection } from '../../components/address-selection';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { Properties } from '../../models/polymer/Properties.model';
import { ApplicationStart } from '../../models/classes/ApplicationStart.class';
import { useForm } from '../../hooks/use-form';
import { useNavigate } from 'react-router-dom';
import { updateApplicationStartFormDataThunk, updateFormData } from '../../redux/slices/application-start-slice';
import { useGetOngoingApplicationQuery } from '../../redux/services/getOngoingApplicationsStatus';
import { Helpers } from '../../utils/helper';
import useCheckSmdByHdbRef from '../../hooks/use-check-sms-by-hdb-ref';
import { API_ApplicationRemove } from '../../utils/api';
import { PolymerAxios } from '../../utils/axios';
import { setActiveApplications } from '../../redux/slices/active-applications-slice';
import { LottieLoader } from '../../components/loader';
import config from '../../config';

function PropertySelection() {

  const navigate = useNavigate();
  const AppDispatch = useAppDispatch();
  const [ isInit, setIsInit ] = useState<boolean>(false);
  const [ continueDraftConfirmation, setContinueDraftConfirmation ] = useState<boolean>(false);
  const properties = useAppSelector(state => state.app.GenuinePolymerSlice.properties);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);

  const { data: ongoingApplications } = useGetOngoingApplicationQuery({uinfin: loginUser?.uinfin, singpass_token: singpassToken ?? ""});
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);
  const { values, setFormValue }: { handleChange: any, values: ApplicationStart, formValid: boolean, setFormValue: (update: any) => void } = useForm(new ApplicationStart(), () => { }, () => { });
  const { smsInfo, isLoading, isError, hasOutstandingFees, hasInitiatedApplication } = useCheckSmdByHdbRef(values.selected_hdb_property?.hdb_ref ?? "", "A");
  const [ hasOutstandingFeesModal, setHasOutstandingFeesModal ] = useState<boolean>(false);
  const [ hasApplicationInitiatedModal, setHasApplicationInitiatedModal ] = useState<boolean>(false);
  const [ hasEstateActionCode, setEstateActionCode] = useState<boolean>(false);
  const existingBb13Applications = useAppSelector(state => state.app.Bb13ApplicationsSlice.bb13Applications);
  const isBtnValid = useMemo((): boolean => {
    return values.selected_hdb_property !== undefined;
  }, [values]);

  const activeApplications = useMemo(() => {
    const nonEligibleStatuses = ["APPLICATION_APPROVED", "APPLICATION_COMPLETED", "APPLICATION_REJECTED", "APPLICATION_CANCELLED", "ARCHIVED", "CANCELLED", "REJECTED", "CLOSED"];
    return ongoingApplications?.filter(item => !nonEligibleStatuses.includes(item.application_status) && item.hdb_ref === values?.selected_hdb_property?.hdb_ref) ?? [];
  }, [ongoingApplications, values])

  const getDraftApplicationDate = useMemo(()=>{
    if(activeApplications?.length > 0 && activeApplications[0]?.application_create_date){
       return Helpers.formatDate(activeApplications[0].application_create_date);
    }else{
      return '-';
    }

  },[activeApplications])

  useEffect(() => {
    AppDispatch(setActiveApplications(activeApplications));
  }, [AppDispatch, activeApplications])

  const checkIsEstateActionCodeExist = useMemo(()=>{
    const Estate_Action_Code_Enum = ["RS", "OT", "ME", "PT", "AJ", "RP", "SU", "SB", "CI", "SE"];
    
    if(smsInfo && Estate_Action_Code_Enum.includes(smsInfo?.financing_info?.estate_action_code)){
      return true;
    }
    else{
      return false;
    }
    
  },[smsInfo])
  /**
   * Check if the selected hdb property address are matches with the current ongoing application api address.
   */
  const { getIsPropertyExisted, application_id } = useMemo(()=>{
    let applicationId = "0";
    if(activeApplications?.length > 0 && activeApplications[0].application_id && activeApplications[0].application_status !== "CLOSED"){
        applicationId = activeApplications[0].application_id;
    }
    return { getIsPropertyExisted: activeApplications?.length > 0, application_id: applicationId  };
  },[activeApplications])


  const navigateToApplication = useCallback(()=>{
    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      const {address, owners, hdb_ref} = values.selected_hdb_property!;
      if(address && hdb_ref){
        setIsInit(false);
        window.location.href = "/transfer/application-coo";
      }
      else{
        setIsInit(false);
        alert("Oops, something wrong with the selected property.");
        navigate("/");
      }
    },1000);
   
    return () => {
      clearTimeout(timeoutId);
    }
  },[navigate, values.selected_hdb_property])

  const processNewApplication = useCallback(async()=>{
    setIsInit(true);
 
    let singlePropertyObj = new Properties(values.selected_hdb_property);
    singlePropertyObj.decryptOwnersOccupiersAdditionalRoles();

    await AppDispatch(updateApplicationStartFormDataThunk({data:new ApplicationStart({ ...startApplicationFormData, has_outstanding_loan: hasOutstandingFees, selected_hdb_property: { ...singlePropertyObj, ...smsInfo } })}))

    let timeoutId: number;
    timeoutId = window.setTimeout(() => {
      navigateToApplication();
    },3000);
   
    return () => {
      clearTimeout(timeoutId);
    }
  
  },[AppDispatch, hasOutstandingFees, navigateToApplication, smsInfo, startApplicationFormData, values.selected_hdb_property])

  const handleContinueDraftApplication = useCallback(()=>{
    console.log('continue draft application_id', application_id);
    if(application_id){
      const url = `/application-coo?application_id=${application_id}`;
      console.log('navigating to:', url);
      navigate(url);    
    }
    else{
      console.log('process new application');
      processNewApplication()
    }
  },[application_id, navigate, processNewApplication])

  const processValidateNewApplication = useCallback(()=>{
    console.log('get is property existed', getIsPropertyExisted);
    if(getIsPropertyExisted){
      const draftStages = [
        "SAVE_DRAFT",
        "SUBMIT_COMPLETE",
        "GATHER_CONSENT_COMPLETE",
        "PENDING_PAYMENT"
      ]
      console.log('application:', activeApplications[0]);
      if(draftStages.includes(activeApplications[0].application_status)){
        console.log('open draft')
        setContinueDraftConfirmation(true);
      }else{
        console.log('continue draft')
        handleContinueDraftApplication();
      }
    }
    else{
      console.log('process new application')
      processNewApplication()
    }
  },[getIsPropertyExisted, processNewApplication, handleContinueDraftApplication, activeApplications])

  const closeEstateActionCode = useCallback(() => {
    setEstateActionCode(false);
  }, [])

  const processNext = useCallback(() =>{
    const findBb13Application = existingBb13Applications.find(item => item.hdb_ref.toLowerCase() === values.selected_hdb_property?.hdb_ref.toLowerCase());
    if(findBb13Application){
        window.location.href = findBb13Application.link;
        return;
    }
    if(isError) {
      alert("An error occurred. Please try again later.");
    }
    else if (checkIsEstateActionCodeExist) {
      setEstateActionCode(true);
    }
    else if(hasInitiatedApplication === true && !config.allowMultipleApplicationDebug) {
      setHasApplicationInitiatedModal(true);
    }
    else if(hasOutstandingFees === true) {
      setHasOutstandingFeesModal(true);
    }
    else if(getIsPropertyExisted){
      processValidateNewApplication();
    }
    else{
      processNewApplication();
    }
  },[checkIsEstateActionCodeExist, existingBb13Applications, hasOutstandingFees, hasInitiatedApplication, values.selected_hdb_property?.hdb_ref, processNewApplication, getIsPropertyExisted, processValidateNewApplication, isError])
  

  const handleModalPrimary = useCallback(()=>{
    setContinueDraftConfirmation(false);
    handleContinueDraftApplication();
  },[handleContinueDraftApplication])

  const removeApplication = useCallback(async () => {
    const application = activeApplications.find(item => item.application_id === application_id);
    if(!application){
      return;
    }

    const draftStages = [
      "SAVE_DRAFT",
      "SUBMIT_COMPLETE",
      "GATHER_CONSENT_COMPLETE",
      "PENDING_PAYMENT"
    ]
    if(draftStages.includes(application.application_status)){
      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken)
          .post(`${API_ApplicationRemove}/${application.application_id}`)
          .then((res) => res.data);
      } catch (error) {
        console.log(error);
      }
    }
  }, [singpassToken, application_id, loginUser, activeApplications]);

  
  const handleModalSecondary = useCallback(()=>{
    removeApplication();
    processNewApplication();
    setContinueDraftConfirmation(false);
  },[processNewApplication, removeApplication])
 

  const handleHasOutstandingLoanPopUp = useCallback(()=>{
    setHasOutstandingFeesModal((prev) => !prev)
    processValidateNewApplication();
  },[processValidateNewApplication])

  const closeContinueDraftConfirmationModal = useCallback(() => {
    setContinueDraftConfirmation(false);
}, [])

  const closeOutstandingFeeModal = useCallback(() => {
    setHasOutstandingFeesModal(false);
  }, [])
  const closeHasInitiatedApplicationModal = useCallback(() => {
    setFormValue({ selected_hdb_property: undefined });
    setHasApplicationInitiatedModal(false);
  }, [setFormValue])

  return (
    <>
      <P2Modal 
        isOpen={isInit}
        children={<LottieLoader/>}
      />
      <ApplicationCooLayout>
        <div className='polymer-start-application'>
          <P2TextDescription titleRequired color={'#333333'} title={'Please select an address.'} />
          <AddressSelection header={["Address", "Role"]} items={properties} onItemSelect={useCallback((value: Properties) => {
            setFormValue({ selected_hdb_property: value });
          },[setFormValue])} value={values.selected_hdb_property} style={{ marginTop: "16px" }} />
        </div>

        <P2ButtonGroup>
          <P2Button style={{marginBottom: "104px"}} variant={"primary-1"} disabled={!isBtnValid || isLoading} onClick={processNext}>{isLoading ? "Checking..." : "Next"}</P2Button>
        </P2ButtonGroup>

      </ApplicationCooLayout>
      <P2Modal
        isOpen={continueDraftConfirmation}
        onCloseModal={closeContinueDraftConfirmationModal}
        variant="default"
        title={`Create new application`}
        primaryButtonText="No, continue current application"
        secondaryButtonText="Yes, create new application"
        primaryButtonFunction={handleModalPrimary}
        secondaryButtonFunction={handleModalSecondary}
        children={<p>A draft application was initiated and saved on {getDraftApplicationDate}. Do you want to create a new application?</p>}
      />
      <P2Modal
        isOpen={hasOutstandingFeesModal}
        onCloseModal={closeOutstandingFeeModal}
        variant="default"
        title={`You having outstanding fee(s)`}
        primaryButtonText="Acknowledge"
        primaryButtonFunction={handleHasOutstandingLoanPopUp}
        children={<p>Please note that you have outstanding fees owing to HDB. Please make the necessary payments before initiating a change in flat ownership application.</p>}
      />
      <P2Modal
        isOpen={hasApplicationInitiatedModal}
        onCloseModal={closeHasInitiatedApplicationModal}
        variant="default"
        title={`This property has been initiated by other applicant`}
        primaryButtonText="Acknowledge"
        primaryButtonFunction={closeHasInitiatedApplicationModal}
        children={<p>Please note that this property has been initiated by other applicant.</p>}
      />
      <P2Modal
        isOpen={hasEstateActionCode}
        onCloseModal={closeEstateActionCode}
        variant="default"
        title={`You cannot start a new application.`} 
        children={<><p>There is another ongoing transaction for the flat, you will not be able to submit a change in flat ownership application.</p></>}
      />
    </>

  )
}

export default PropertySelection